import React from "react"
import propTypes from "prop-types"
import "./styles.scss"

import Group from "./components/Group"
import Description from "./components/Description"
import ErrorMessage from "./components/ErrorMessage"
import GeneralErrorMessage from "./components/GeneralErrorMessage"
import Label from "./components/Label"
import Input from "./components/Input"
import File from "./components/File"
import TextArea from "./components/TextArea"
import Checkbox from "./components/Checkbox"
import Password from "./components/Password"
import Select from "./components/Select"
import Radio from "./components/Radio"

const Form = ({ children, onSubmit, className, formRef }) => {
  return (
    <form
      className={["form", className].join(" ")}
      onSubmit={onSubmit}
      noValidate="novalidate"
      ref={formRef}
    >
      {children}
    </form>
  )
}

Form.propTypes = {
  children: propTypes.oneOfType([propTypes.node, propTypes.string]).isRequired,
  onSubmit: propTypes.func,
  className: propTypes.string,
  formRef: propTypes.func
}

Form.defaultProps = {
  className: "form--dark",
  formRef: () => {},
  onSubmit: e => {
    e.preventDefault()
  }
}

export {
  Group,
  Description,
  ErrorMessage,
  GeneralErrorMessage,
  Label,
  Input,
  File,
  Radio,
  TextArea,
  Checkbox,
  Password,
  Select
}

export default Form
